import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarningIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 16,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#ff5050",
		d: "M9.15 1.36a1 1 0 0 1 1.7 0l8.2 13.11A1 1 0 0 1 18.2 16H1.8a1 1 0 0 1-.85-1.53Z"
	}), /* @__PURE__ */ _jsx("text", {
		fill: "#ffdcdc",
		fontFamily: "Quicksand-Bold, Quicksand",
		fontSize: 8,
		fontWeight: 700,
		transform: "translate(9 5)",
		children: /* @__PURE__ */ _jsx("tspan", {
			x: 0,
			y: 8,
			children: "!"
		})
	})]
});
export default SvgWarningIcon;
